"use strict";

var _regeneratorRuntime = require("/home/im/impactminer/imfrontend/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/im/impactminer/imfrontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/im/impactminer/imfrontend/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var path_mapper_1 = require("./path-mapper");

var functions_1 = require("./functions");

var inner_1 = require("./inner");
/**
 * Updates the master model and responds to flush batches, providing diffs from an optional
 * history provider.
 */


var Master =
/*#__PURE__*/
function () {
  function Master(snapshot, config) {
    _classCallCheck(this, Master);

    this.model = new inner_1.Inner(snapshot, config ? !!config.sequentialIds : false);
    this.historyProvider = config ? config.historyProvider : undefined;
    this.interceptor = config ? config.interceptor : undefined;
  }

  _createClass(Master, [{
    key: "getSnapshot",
    value: function getSnapshot() {
      return {
        commandCount: this.model.getCommandCount(),
        document: this.model.getDocument()
      };
    }
    /**
     * Applies the flushed commands to the model and returns a result that contains the commands
     * that were successfully applied and from what update count, any errors that occurred when
     * applying the commands, and optionally a sync object to bring the requesting Proxy up to
     * the same state as the master. If the Master was constructed with a history provider, the
     * sync object may be a partial diff that returns the commands needed to update the proxy
     * from the batch's update count to the master's current state.
     * @param batch
     */

  }, {
    key: "apply",
    value: function apply(batch, context) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var startUpdate, pathMapper, result, needsSync, applied, sync, needsHistory, historyDiff, diff;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                startUpdate = this.model.getCommandCount();
                pathMapper = new path_mapper_1.PathMapper();
                result = functions_1.applyCompletions(this.model, batch.completions, pathMapper, this.interceptor, context);
                needsSync = batch.from !== startUpdate || result != undefined;
                applied = {
                  from: startUpdate,
                  completions: result == undefined ? batch.completions : result.applied.completions
                };

                if (!needsSync) {
                  _context.next = 17;
                  break;
                }

                needsHistory = batch.from !== startUpdate;

                if (!needsHistory) {
                  _context.next = 16;
                  break;
                }

                if (!this.historyProvider) {
                  _context.next = 14;
                  break;
                }

                _context.next = 11;
                return this.historyProvider(batch.from, startUpdate);

              case 11:
                _context.t0 = _context.sent;
                _context.next = 15;
                break;

              case 14:
                _context.t0 = undefined;

              case 15:
                historyDiff = _context.t0;

              case 16:
                if (needsHistory && (historyDiff == undefined || historyDiff.length !== startUpdate - batch.from)) {
                  sync = {
                    isPartial: false,
                    mappedPaths: pathMapper.getMappings(),
                    latest: this.getSnapshot()
                  };
                } else {
                  diff = {
                    from: batch.from,
                    completions: historyDiff ? historyDiff.concat(applied.completions) : applied.completions
                  };
                  sync = {
                    isPartial: true,
                    diff: diff,
                    mappedPaths: pathMapper.getMappings()
                  };
                }

              case 17:
                return _context.abrupt("return", {
                  sync: sync,
                  applied: applied,
                  errors: result == undefined ? undefined : result.errors
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return Master;
}();

exports.Master = Master;